<template>
  <section class="header-wrapper">
    <div class="flex items-center space-x-5">
      <div class="flex-shrink-0">
        <div class="relative">
          <Twemoji :code="practice.emoji" class="twemoji" :class="{'bg-green-100': applied, 'bg-amber-100': bookmarked, 'bg-gray-100': true}"/>
        </div>
      </div>
      <div>
        <h1 class="text-3xl font-bold text-white mb-4">
          {{ practice.title }}
        </h1>
        <div class="text-sm text-white font-medium">
          <Similarity :value="practice.similarity" class="mr-2" />
          <Accessible :value="practice.accessible" />
        </div>
      </div>
    </div>
    <div class="mt-5 flex justify-center sm:mt-0">
      <ActionButton v-if="admin" @click="edit" class="mr-4">
        <PencilSquareIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
        <span class="ml-3">
          Bearbeiten
        </span>
      </ActionButton>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const props = defineProps({practice: Object});

const router = useRouter();
const store = useStore();

const admin = computed(() => store.getters["auth/nova"]);
const parent = computed(() => props.practice.id);
const target = computed(() => '/nova/resources/practices/' + parent.value);

const applied = computed(() => props.practice.applied);
const bookmarked = computed(() => props.practice.bookmarked);

const edit = () => window.open(target.value);
</script>

<style scoped>
.header-wrapper
{
  @apply max-w-3xl mx-auto;
  @apply md:flex md:items-center md:justify-between;
  @apply md:space-x-5 lg:max-w-7xl;
};

.twemoji
{
  @apply w-20 h-20 p-4 mr-2;
  @apply rounded-full;
  @apply relative;
};
</style>
